import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';
import { centsToDollarAmount } from 'helpers';
import { EstatePayment } from 'queries';

const useStyles = makeStyles(() => ({
  stackedDataFirst: {
    display: 'block',
    lineHeight: '1.43',
    width: '100%',
  },
}));

type EstateWorkItemPaymentDetailsProps = {
  estatePayment: EstatePayment;
};

const EstateWorkItemPaymentDetails = ({ estatePayment }: EstateWorkItemPaymentDetailsProps) => {
  const classes = useStyles();
  const couponCode = estatePayment.coupon?.code || 'N/A';
  const paymentDate = estatePayment.createdAt;
  const date = format(Date.parse(paymentDate!.toString()), 'LLL d y');
  const time = format(Date.parse(paymentDate!.toString()), 'h:mm aaa');
  const paymentNotes = estatePayment.notes || 'N/A';
  const paymentQuantity = estatePayment.quantity || 1;

  return (
    <div>
      <div>
        <strong>Date:</strong> {date}
      </div>
      <div>
        <strong>Time:</strong> {time}
      </div>
      <div>
        <strong>Amount paid:</strong> ${centsToDollarAmount(estatePayment.amountPaid)}
      </div>
      <div>
        <strong>Coupon code:</strong> {couponCode}
      </div>
      <div>
        <strong>Stripe payment id:</strong> {estatePayment.stripePaymentId || 'N/A'}
      </div>
      <div className={classes.stackedDataFirst}>
        <strong>Notes:</strong>
        <Typography variant="caption"> {paymentNotes}</Typography>
      </div>
      <div className={classes.stackedDataFirst}>
        <strong>Quantity:</strong> {paymentQuantity}
      </div>
    </div>
  );
};

export default EstateWorkItemPaymentDetails;
